export function can(user, perm) {
  if (!user) return false;
  if (user.is_super_admin) return true;
  if (["owner", "master"].includes(user.role)) return true;
  return (user.permissions || []).includes(perm);
}

export function isOwner(user) {
  return !!user && (user.is_super_admin || ["owner", "master"].includes(user.role));
}

export const PERM_LABELS = {
  manage_raffles: "Crear y editar rifas",
  verify_payments: "Verificar pagos (aprobar / rechazar)",
  execute_draw: "Ejecutar sorteos",
};
export const ALL_PERMS = ["manage_raffles", "verify_payments", "execute_draw"];

// ---------------- Planes (mirror del backend) ----------------
export const PLAN_PRESETS_FE = {
  free: { max_active_raffles: 1, max_numbers_per_raffle: 100, max_assistants: 0, max_photos: 3, can_download_csv: false, can_view_history: false, adv_stats: false, white_label: false, qr_tickets: false },
  full: { max_active_raffles: 3, max_numbers_per_raffle: 2000, max_assistants: 3, max_photos: 5, can_download_csv: true, can_view_history: true, adv_stats: false, white_label: false, qr_tickets: false },
  pro: { max_active_raffles: 5, max_numbers_per_raffle: 9000, max_assistants: 5, max_photos: 10, can_download_csv: true, can_view_history: true, adv_stats: true, white_label: true, qr_tickets: true },
};

export const PLAN_LABELS = { free: "Gratis", full: "Full", pro: "Pro", custom: "Custom" };

export function resolvePlanFE(o) {
  o = o || {};
  const plan = o.plan || "free";
  if (plan === "custom") {
    const cp = o.custom_perms || {};
    const ma = o.max_assistants != null ? o.max_assistants : (cp.can_create_assistants ? 9999 : 0);
    return {
      plan: "custom",
      max_active_raffles: o.max_active_raffles != null ? o.max_active_raffles : 9999,
      max_numbers_per_raffle: o.max_numbers_per_raffle != null ? o.max_numbers_per_raffle : 10000,
      max_assistants: ma,
      max_photos: o.max_photos != null ? o.max_photos : 5,
      can_download_csv: !!cp.can_download_csv,
      can_view_history: !!cp.can_view_history,
      adv_stats: !!cp.adv_stats,
      white_label: !!cp.white_label,
    };
  }
  const base = { ...(PLAN_PRESETS_FE[plan] || PLAN_PRESETS_FE.free), plan: PLAN_PRESETS_FE[plan] ? plan : "free" };
  ["max_active_raffles", "max_numbers_per_raffle", "max_assistants", "max_photos"].forEach((k) => {
    if (o[k] != null) base[k] = o[k];
  });
  return base;
}

// Devuelve los features efectivos: usa el `eff` del backend si viene, si no lo calcula
export function effOf(user, sim) {
  if (sim) return resolvePlanFE(sim);
  if (user?.eff) return { ...user.eff };
  return resolvePlanFE(user);
}
